import { AvailableUserEnum } from '../../../enums/available-user.enum';
import { Company } from '../../../entities/company.type';
import { PlaylistDTO } from '../../playlist-models/playlist-dto.model';
import { Monitor } from '../../../entities/monitor.type';
import { TagViewModel } from '../../tag-models/tag-view.model';
import { MachineCategory } from '../../../entities/machine-category.type';

export class DisplayAccountViewModel {
  Id: string;
  Email: string;
  FirstName: string;
  LastName: string;
  Language: string;
  EmailConfirmed: boolean;
  Roles: string[] = [];
  IsMainDashboardAllowed: boolean;
  AvailableMonitors: Monitor[] = [];
  AvailableCategories: MachineCategory[] = [];
  SharedPlaylists: PlaylistDTO[] = [];
  SharedMonitorTags: TagViewModel[] = [];
  UserIdsSharedAllPlaylists: string[] = [];
  CompanyId: number;
  Company: Company;
  DateRegistered: Date;
  LastLoginDate: Date;
  AccountStatus: AvailableUserEnum;
  HasAccessToRemoteControl: boolean;
  HasAccessToDisconnectAgents: boolean;
  TwoFactorEnabled: boolean;
  ShouldConfirmEmail: boolean;
  ShouldPasswordExpire: boolean;
  ShouldAcceptLegalConsent: boolean;
  LastPasswordUpdateDate: Date;
  OldPassword?: string;
  NewPassword?: string;
  ConfirmPassword?: string;
}
